import { CheckCircle, Clock } from "lucide-react";

import { Card, CardContent } from "@/app/_module/components/ui/card";

interface PowerDialerStatsProps {
  successCount: number; // Represents "Answered" count
  totalDialTime: number; // Total dial time in seconds
  appointments?: number; // Leads marked as Appt
  underwriting?: number; // Leads marked as Underwriting
  sold?: number; // Leads marked as Sold & Approved
}

// Format seconds into HH:MM:SS or MM:SS
function formatDialTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
}

export const PowerDialerStats = function({
  successCount,
  totalDialTime,
  appointments = 0,
  underwriting = 0,
  sold = 0,
}: PowerDialerStatsProps) {
  return (
    <Card className="h-full flex items-center justify-center">
      <CardContent className="text-center py-8">
        <CheckCircle className="h-12 w-12 mx-auto mb-4 text-green-500" />
        <h3 className="text-xl font-semibold mb-2">
          Session Complete!
        </h3>
        <p className="text-muted-foreground">All leads have been processed.</p>

        {/* Basic Stats */}
        <div className="mt-4 grid grid-cols-2 gap-4 text-center max-w-xs mx-auto">
          <div className="bg-green-50 rounded-lg p-3">
            <div className="text-2xl font-bold text-green-600">
              {successCount}
            </div>
            <div className="text-sm text-green-600">Answered</div>
          </div>
          <div className="bg-blue-50 rounded-lg p-3">
            <div className="text-2xl font-bold text-blue-600 flex items-center justify-center gap-1">
              <Clock className="h-5 w-5" />
              {formatDialTime(totalDialTime)}
            </div>
            <div className="text-sm text-blue-600">Total Dial Time</div>
          </div>
        </div>

        {/* Outcome Stats - Always show all 3 */}
        <div className="mt-3 grid grid-cols-3 gap-2 text-center max-w-xs mx-auto">
          <div className="bg-cyan-50 rounded-lg p-2">
            <div className="text-lg font-bold text-cyan-600">{appointments}</div>
            <div className="text-xs text-cyan-600">Appt</div>
          </div>
          <div className="bg-amber-50 rounded-lg p-2">
            <div className="text-lg font-bold text-amber-600">{underwriting}</div>
            <div className="text-xs text-amber-600">UWR</div>
          </div>
          <div className="bg-emerald-50 rounded-lg p-2">
            <div className="text-lg font-bold text-emerald-600">{sold}</div>
            <div className="text-xs text-emerald-600">Sold</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
